<ng-template #content let-modal>
	<div class="modal-body modal-image" [ngStyle]="{'background-image': modalImg()}">
    <button class="modal-close" type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
		<p class="modal-winner">{{message}}</p>
    <p class="modal-raffle">{{raffle}}</p>
	</div>
</ng-template>

<section class="event header" [ngStyle]="{'background-image': 'url(assets/images/event/event_slider.jpg)'}">
    <div class="header3 bg">
        <div #spinners id="app" [@bounce]="{ value: bounce }">
            <div class="text-center" style="margin-bottom: 5rem;">
                <!-- <h1 class="header-title">
                    <span style="font-size: larger; color: #474747; font-family: Impact !important;">RAPOL APP</span>
                </h1>
                <h6 style="color: #dbdbdb;">Powered by ERPat System </h6> -->
            </div>
            <!-- <div class="back" [ngStyle]="{'background-image': 'url(assets/images/logo-banner.png)'}"></div> -->
            <div class="doors" [ngStyle]="{'background-image': 'url(assets/images/spinner_view.png)'}">
              <div class="door" *ngFor="let slot of slots">
                <div class="boxes" [style.transform]="getTranslate(slot)">
                    <div class="box" *ngFor="let item of items" [style.filter]="getFilter(slot)" [ngStyle]="{'background-image': 'url(assets/images/event/slot.png)'}"><h1 class="slot-text" >{{item}}</h1></div>
                </div>
              </div>
            </div>
            <div class="buttons">
              <div><h2 style="color: #f560bc;">{{instance.title}}</h2></div>
            </div>
            <div class="buttons">
              <button class="btn play" (click)="startSpinnerGame()" [disabled]="active || completed">START DRAW</button>
            </div>
            <div style="z-index: 999; margin-top: 10px; width: 100vw; padding: 0 4em; margin-bottom: 1.5em;">
              <h4 class="win-title" style="color: #f560bc;">ALL WINNERS ({{allWinners?.length}}/{{instance.winners}})</h4>
              <div style="display: -webkit-box; overflow-x: scroll;">
                <div *ngFor="let win of allWinners; index as page;" class="winbox text-white">
                  <strong style="font-size: 1.2 em;">{{win.user_name ? win.user_name : win.remarks }}</strong>
                  <span style="display: block; width: -webkit-fill-available;font-size: small;">{{win.uuid}}</span>
                </div>
              </div>
            </div>
          </div>
    </div>
</section>
